enum Layout {
  LARGE = 'LARGE',
  NORMAL = 'NORMAL',
  LIST = 'LIST',
}

export default Layout;

export const isLayout = (x: any): x is Layout =>
  Object.keys(Layout).includes(x);
